import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AttachmentPoint } from '../../models/attachmentpoint';
import { AttachmentPointService } from '../../services/attachment-point.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-attachmentpoints-multiple-delete',
  templateUrl: './attachmentpoints-multiple-delete.component.html',
  styleUrls: ['./attachmentpoints-multiple-delete.component.css']
})
export class AttachmentpointsMultipleDeleteComponent implements OnInit {

  attachmentPoints : Array<AttachmentPoint>;
  @Output() onDeleteValidation = new EventEmitter<boolean>();
  
  constructor(private apService : AttachmentPointService,
              public activeModal : NgbActiveModal) { }

  ngOnInit() {
  }

  onDeleteClick() {
    // TODO 
  }

}



// WEBPACK FOOTER //
// ./src/app/attachmentpoints/attachmentpoints-multiple-delete/attachmentpoints-multiple-delete.component.ts